<template>
  <div :class="containerClass">
    <PerformanceHeader v-if="!isEmbedded"/>
    <PerformanceTable
      :chatbots="chatbots"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PerformanceHeader from '@/views/DashBoard/Performance/PerformanceHeader'
import PerformanceTable  from '@/views/DashBoard/Performance/PerformanceTable'
export default {
  name: 'PerformanceView',
  componentName: 'PerformanceView',
  components: {
    PerformanceHeader,
    PerformanceTable
  },
  props: {
    isEmbedded: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('chatbot', ['chatbots']),
    ...mapState("setting",["isMenuMiniSize"]),
    containerClass() {
      if (this.isEmbedded) {
        return 'embedded-container'
      }
      return {
        'root-container': !this.isMenuMiniSize,
        'root-container-thin-menu': this.isMenuMiniSize
      }
    }
  },
  created () {
    this.$store.dispatch('chatbot/getChatBots')
  },
  mounted () {
    // Virtual Office接続はisEmbedded=falseの時のみ
    if (!this.isEmbedded) {
      const uriVO = process.env.WS_ENDPOINT + 'vo/user_list/' + this.user.companyID + '/' + this.user.userHash
      this.$store.dispatch('virtualOffice/connectVirtualOfficeSV', uriVO)
      const con = {
        'is_connect': true
      }
      this.$store.dispatch('auth/setUserConnect', con)
    }
  },
}
</script>

<style lang="scss" scoped>
.root-container {
  height: 100vh;
  width: calc(100% - 200px);
  overflow: auto;
}
.root-container-thin-menu {
  height: 100vh;
  width: calc(100% - 55px);
  overflow: auto;
}
.embedded-container {
  height: calc(100vh - 73px);
  width: 100%;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Performance/PerformanceView.vue